import React from 'react';
import SelectInput from '@/components/General/inputs/SelectInput';

/**
 * Renders `dropdown` schema fields (single-select). Reuses `SelectInput` with
 * the field's fixed `config.options` list. Multi-select is handled by
 * `CheckboxGroupField`, not here.
 */
const DropdownField = ({ field, value, onChange, disabled }) => {
    const config = field.config || {};
    const options = (config.options || []).map((opt) => {
        if(typeof opt === 'object' && opt !== null) return opt;
        return { label: String(opt), value: String(opt) };
    });

    return (
        <SelectInput
            testID={`form-field-${field.fieldId}`}
            title={field.label}
            placeholder={field.placeholder || 'Select an option'}
            value={value ?? null}
            onUpdate={onChange}
            options={options}
            required={field.required}
            helpText={field.description}
            disabled={disabled}
            hideClearButton={disabled}
        />
    );
};

export default DropdownField;
